import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '地标有颜值，城市有温度——双城新发现·第三季';
const baseUrl = '20220531SCXFX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsdh',
      name: `${baseUrl}-newsdh`,
      component: () => import('./pages/NewsDh.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newswl',
      name: `${baseUrl}-newswl`,
      component: () => import('./pages/NewsWl.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
